import { resolveImageUrl } from '@/shared/utils/publishingAsset';
import CardSlideFlex from '@publishing/modules/card/CardSlideFlex';
import { resolveResponsiveImage } from '@publishing/helpers/responsive';
import type {
  CarouselTabsImage,
  CarouselTabsTab,
  CarouselTabsTheme,
} from './types';
import { SlideImage } from './SlideImage';

/** 슬라이드 리스트의 React key — 이미지 URL·alt·index 조합 */
export function getSlideKey(
  image: CarouselTabsImage,
  alt: string | undefined,
  index: number,
) {
  const [pcImage] = resolveResponsiveImage(image);
  return `${resolveImageUrl(pcImage)}-${alt ?? ''}-${index}`;
}

export function TabSlide({
  image,
  index,
  tab,
  theme,
  imageClassName,
}: {
  image: CarouselTabsImage;
  index: number;
  tab: CarouselTabsTab;
  theme: CarouselTabsTheme;
  imageClassName: string;
}) {
  if (tab.title != null) {
    return (
      <CardSlideFlex
        item={{
          images: resolveResponsiveImage(image),
          alt: tab.alt,
          title: tab.title,
          text: tab.text,
          badge: tab.badges?.[index],
          note: tab.note,
        }}
        theme={theme}
      />
    );
  }

  return (
    <SlideImage
      image={image}
      alt={tab.alt}
      className={imageClassName}
      caption={tab.caption}
    />
  );
}
